// External Imports
import get from 'lodash/fp/get';
import { createSelector } from 'reselect';

// Internal Imports
import { getSearchParameters } from './searchSelectors.js';
import { getMatch } from './getMatch.js';
import { hasFetchedActiveContent } from './hasFetchedActiveContent.js';
import { CATCH_ALL } from '../config/types/path.js';

// Local Functions
const getIsRoute404 = createSelector([getMatch], (match) => !match || match.pathType === CATCH_ALL);

const getIsContent404 = createSelector(
  [
    hasFetchedActiveContent,
    get('active.loading.content'),
    get('active.loading.more'),
    getSearchParameters,
  ],
  (hasFetched, isLoading, isLoadingMore, { s }) =>
    !(isLoading || isLoadingMore) && !hasFetched && !s,
);

const getIs404 = createSelector(
  [getIsContent404, getIsRoute404],
  (content404, route404) => content404 || route404,
);

// Module Exports
export { getIs404, getIsRoute404 };
